import { component$ } from '@builder.io/qwik';
import type { HTMLBlockInterface } from '~/types/AppData/PageBuilder/HTMLBlockInterface';

export default component$<HTMLBlockInterface['props']>(({ html }) => {
  return (
    <div
      dangerouslySetInnerHTML={html}
      class={`[&_ol]:list-[revert] [&_ul]:list-[revert] [&_ol]:list-inside [&_ul]:list-inside
      [&_a]:underline [&_a]:md:no-underline [&_a]:hover:underline [&_a]:text-primary [&_p]:text-group-normal`}
    />
  );
});
